import Box from "@/common/components/Box";
import ResumeBox from "@/common/components/ResumeBox";
import Skeleton from "@/common/components/Skeleton";
import { CalendarDaysIcon } from "lucide-react";

const NegotiationProductHistoriesLoadingState = () => {
  return (
    <>
      {new Array(1).fill(null).map((_, i) => (
        <div key={`negotiation-product-history-loading-${i}`} className="flex flex-col gap-3">
          <div className="flex justify-between">
            <div className="flex flex-col gap-1">
              <div className="flex items-center gap-2">
                <Skeleton circle className="size-7 bg-white-100" />
                <Skeleton className="w-28 bg-white-100" />
              </div>

              <Skeleton className="w-28 h-4 bg-white-100" />
            </div>

            <div className="flex items-center gap-2">
              <CalendarDaysIcon strokeWidth={1.5} size={18} />

              <Skeleton className="w-24 bg-white-100" />
            </div>
          </div>

          <Box className="p-4 rounded-lg flex flex-col gap-4">
            <ResumeBox
              label="Valor proposto"
              value={<Skeleton className="w-24" />}
            />

            <ResumeBox
              label="Justificativa"
              value={<Skeleton className="w-36" />}
            />
          </Box>
        </div>
      ))}
    </>
  );
};

export default NegotiationProductHistoriesLoadingState;
